module.exports = __webpack_public_path__ + "media/images/turbochargers/BorgWarner_old-13d6724eb81d94b6e2b42d9cd08bc5cf.jpg";